import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  helperRow: {
    height: '15px',
    fontFamily: 'Roboto',
    fontSize: '12px',
    display: 'flex',
    justifyContent: 'space-between',
  },
  helperText: {
    display: 'flex',
    position: 'relative',
    left: '-10px',
    minWidth: '120%',
  },
  fieldLimits: {
    textAlign: 'right',
    color: '#2C2D3E',
  },
  error: {
    color: 'red',
  },
}));
